/**
 * istanbul ignore file
 *
 * @format
 */

import { AppointmentListResponse } from '@my-account/data-access/interfaces';
import { Environment } from '@shared/data-access/interfaces';
import { HttpService } from '@shared/data-access/services';
import { Injectable } from '@angular/core';
import { MediaType } from '@shared/data-access/enums';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class GameTimeDao {
	constructor(
		private http: HttpService,
		private environment: Environment
	) {}

	// Default HTTP Header properties
	private DEFAULT_HTTP_HEADER_PROPERTIES = {
		Accept: MediaType.APPLICATION_JSON,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		'Content-Type': MediaType.APPLICATION_JSON,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
		Pragma: 'no-cache',
		Expires: 'Sat, 01 Jan 2000 00:00:00 GMT'
	};

	/**
	 * @description
	 * Retrieves athlete's appointments from GameTime
	 */
	public fetchAppointments(options?: {
		endDate?: string;
		startDate?: string;
	}): Observable<AppointmentListResponse> {
		const httpOptions = {
			headers: this.DEFAULT_HTTP_HEADER_PROPERTIES,
			withCredentials: true,
			useApiAuth: true
		};

		const params = new URLSearchParams(options);

		return this.http.get<AppointmentListResponse>(
			`${this.environment.baseUrls.gameTimeApi}/api/v1/athletes/me/appointments?${params}`,
			null,
			httpOptions
		);
	}
}
